import type { FunctionComponent } from 'react';

import { AnimatedIconRoot } from '../animatedIconRoot';

import styles from './PlayingNowIcon.module.css';

export const PlayingNowIcon: FunctionComponent = () => {
  return (
    <AnimatedIconRoot className={styles.playingNowIcon}>
      <span className={styles.playingNowIcon__stick} />
      <span className={styles.playingNowIcon__stick} />
      <span className={styles.playingNowIcon__stick} />
      <span className={styles.playingNowIcon__stick} />
    </AnimatedIconRoot>
  );
};
